"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var MobileActivePay = function MobileActivePay(props) {
  var className = props.className,
    style = props.style,
    left = props.left,
    right = props.right,
    children = props.children;
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('mobile-active-pay');
  var classes = (0, _classnames.default)(prefixCls, className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes,
    style: style
  }, left && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__item ").concat(prefixCls, "__left")
  }, left), right && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__item ").concat(prefixCls, "__right")
  }, right));
};
var _default = MobileActivePay;
exports.default = _default;